'use strict';

const isInstanceOf = require('../rlink-type-utils/isInstanceOf');

module.exports = function arrayOf (valueChecker, ...args) {
  const checker = (obj, key, cname, location, fullName) => {
    const value = obj[key];

    if (!isInstanceOf(value, Array)) {
      return new TypeError(`Value at ${fullName} is not an array.`);
    }

    for (let idx of value.keys()) {
      let check = valueChecker(value, idx, cname, location, `${fullName}[${idx}]`);
      if (check) {
        return check;
      }
    }
  };
  checker.getCheckerForKey = () => valueChecker;
  checker.makeNew = () => [];
  checker.checkerName = 'arrayOf';

  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }
  if (typeof valueChecker !== 'function') {
    throw new Error(`Invalid checker for ${checker.checkerName}: ${valueChecker}`);
  }
  if (!valueChecker.checkerName) {
    throw new Error(`Non-rlink-shape checker for ${checker.checkerName}. Are you trying to mix shapes and PropTypes? (this is not supported)`);
  }
  return checker;
};



// WEBPACK FOOTER //
// ./lib/rlink-shapes/arrayOf.js